<template>
  <div class="card">
    <div class="pb-0 card-header mb-0">
      <h5>{{ title }}</h5>
      <p class="text-sm">
        <span class="font-weight-bold">{{ detail1 }}</span>
        {{ detail2 }}
      </p>
    </div>
    <div class="p-3 card-body">
      <div class="chart">
        <canvas id="chart-line" class="chart-canvas" height="300"></canvas>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js/auto";

export default {
  name: "gradient-line-chart",
  data() {
    return {
      data: {},
    }
  },
  props: {
    title: {
      type: String,
      default: "Producciones del Año",
    },
    detail1: {
      type: String,
      default: "",
    },
    detail2: {
      type: String,
      default: "",
    },
  },
  methods: {
    async fetchYearAnalytics() {
      try {
        let grafico = await this.$store.dispatch('analitycs/getYear');

        // Si el backend no responde como se espera, evitamos romper el Dashboard
        this.data = grafico?.data ?? [];
        this.updateChart();
      } catch (e) {
        this.data = [];
      }
    },
    updateChart() {
      const months = [];
      const programadas = [];
      const terminadas = [];

      // Extraer los datos necesarios
      this.data.forEach(item => {
        months.push(item.mes); // Meses
        programadas.push(item.programadas); // Producciones programadas
        terminadas.push(item.terminadas); // Producciones terminadas
      });

      const canvas = document.getElementById("chart-line");
      if (!canvas) {
        // Si el componente se desmontó o aún no renderizó el canvas, evitamos romper el Dashboard
        return;
      }

      const ctx1 = canvas.getContext("2d");
      if (!ctx1) return;

      new Chart(ctx1, {
        type: "bar",
        data: {
          labels: months,
          datasets: [
            {
              label: "Programadas",
              backgroundColor: "rgba(249, 176, 2,0.5)",
              data: programadas,
              barThickness: 50, // Grosor de las barras
            },
            {
              label: "Terminadas",
              backgroundColor: "rgba(45, 206, 137, 0.5)",
              data: terminadas,
              barThickness: 50, // Grosor de las barras
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: true,
            },
            tooltip: {
              callbacks: {
                label: function (context) {
                  const index = context.dataIndex;
                  // Solo mostrar la información de la barra seleccionada
                  const label = context.dataset.label;
                  const value = context.raw; // Valor de la barra seleccionada
                  const totalRecords = this.data[index].total_records;
                  const totalGlobal = parseFloat(this.data[index].total_global).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

                  return [
                    `Mes: ${months[index]}`,
                    `${label}: ${value}`,
                    `Total de Registros: ${totalRecords}`,
                    `Valor Total: ${totalGlobal}`,
                  ];
                }.bind(this), // Asegúrate de mantener el contexto de `this`
              },
            },
          },
          interaction: {
            intersect: true, // Cambiado a true para que el tooltip se muestre solo en la barra más cercana
            mode: "nearest", // Cambiado a nearest para que el tooltip se muestre solo en la barra más cercana
          },
          scales: {
            y: {
              grid: {
                drawBorder: false,
                display: true,
                drawOnChartArea: true,
                drawTicks: false,
                borderDash: [5, 5],
              },
              ticks: {
                display: true,
                padding: 10,
                color: "#000",
                font: {
                  size: 12,
                  family: "Open Sans",
                  style: "normal",
                  lineHeight: 2,
                },
              },
            },
            x: {
              grid: {
                drawBorder: false,
                display: false,
                drawOnChartArea: false,
                drawTicks: false,
                borderDash: [5, 5],
              },
              ticks: {
                display: true,
                color: "#000",
                padding: 20,
                font: {
                  size: 12,
                  family: "Open Sans",
                  style: "normal",
                  lineHeight: 2,
                },
              },
              offset: true, // Centrar las barras con respecto a los labels
            },
          },
        },
      });
    }
  },
  mounted() {
    this.fetchYearAnalytics();
  },
};
</script>
